import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { I18NEXT_SERVICE } from 'angular-i18next';
import { environment } from 'src/environments/environment';
import { HelperService } from 'utils/helper';
import { routes } from 'utils/routes';

export const messagesGuard: CanActivateFn = (_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
  const usingCapacitor = Capacitor.isNativePlatform();
  const production = environment.production;
  const router = inject(Router);
  const language = inject(I18NEXT_SERVICE).language;
  const isMobile = inject(HelperService).isMobile();
  if (!usingCapacitor && production && isMobile) {
    return router.parseUrl(`/${language}/${routes[language as 'it']['routes.not-implemented']}`);
  }
  return true;
};
